var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhConsumerSnapshotTaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 726.675,
    viewBox: "0 0 800 726.675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7779",
    "data-name": "Group 7779",
    transform: "translate(6068 -6646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 255.627,
    height: 171.745,
    rx: 9.61,
    transform: "translate(-5880.366 6694.218)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1466",
    "data-name": "Rectangle 1466",
    width: 244.33,
    height: 147.558,
    transform: "translate(-5874.992 6707.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_409",
    "data-name": "Ellipse 409",
    cx: 2.152,
    cy: 2.327,
    rx: 2.152,
    ry: 2.327,
    transform: "translate(-5755.378 6698.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1467",
    "data-name": "Rectangle 1467",
    width: 44.79,
    height: 47.278,
    transform: "translate(-5775.62 6859.742)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10600",
    "data-name": "Path 10600",
    d: "M463.3,326.95h54.743a7.465,7.465,0,0,1,7.465,7.465H455.84a7.465,7.465,0,0,1,7.46-7.465Z",
    transform: "translate(-6242.658 6576.338)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1468",
    "data-name": "Rectangle 1468",
    width: 184.137,
    height: 63.453,
    transform: "translate(-6064.267 6943.101)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1469",
    "data-name": "Rectangle 1469",
    width: 39.813,
    height: 345.879,
    transform: "translate(-5307.813 6910.753)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1470",
    "data-name": "Rectangle 1470",
    width: 184.137,
    height: 3.733,
    transform: "translate(-6064.267 6943.101)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1471",
    "data-name": "Rectangle 1471",
    width: 184.137,
    height: 63.453,
    transform: "translate(-6064.267 7004.066)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_410",
    "data-name": "Ellipse 410",
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(-5982 7026.406)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_411",
    "data-name": "Ellipse 411",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(-5982 6962.406)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1472",
    "data-name": "Rectangle 1472",
    width: 184.137,
    height: 63.453,
    transform: "translate(-6064.267 7067.518)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_412",
    "data-name": "Ellipse 412",
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(-5982 7088.406)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1473",
    "data-name": "Rectangle 1473",
    width: 184.137,
    height: 63.453,
    transform: "translate(-6064.267 7130.971)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_413",
    "data-name": "Ellipse 413",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(-5982 7152.406)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1474",
    "data-name": "Rectangle 1474",
    width: 184.137,
    height: 63.453,
    transform: "translate(-6064.267 7194.424)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_414",
    "data-name": "Ellipse 414",
    cx: 9.5,
    cy: 10,
    rx: 9.5,
    ry: 10,
    transform: "translate(-5982 7215.406)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1475",
    "data-name": "Rectangle 1475",
    width: 184.137,
    height: 4.977,
    transform: "translate(-6064.267 7063.786)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1476",
    "data-name": "Rectangle 1476",
    width: 184.137,
    height: 4.977,
    transform: "translate(-6064.267 7001.577)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1477",
    "data-name": "Rectangle 1477",
    width: 184.137,
    height: 4.977,
    transform: "translate(-6064.267 7127.238)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1478",
    "data-name": "Rectangle 1478",
    width: 184.137,
    height: 4.977,
    transform: "translate(-6064.267 7190.691)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 800,
    height: 37.325,
    transform: "translate(-6068 6907.021)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1480",
    "data-name": "Rectangle 1480",
    width: 114.463,
    height: 120.97,
    transform: "translate(-5868.933 6723.979)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1481",
    "data-name": "Rectangle 1481",
    width: 109.487,
    height: 115.708,
    transform: "translate(-5866.445 6726.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1482",
    "data-name": "Rectangle 1482",
    width: 42.364,
    height: 31.963,
    transform: "translate(-5832.653 6760.694)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10601",
    "data-name": "Path 10601",
    d: "M499.969,301.075l-16.348,23.042-17.157-1.481s-22.3,1.481-7.465-15.614c7.141-8.212,9.481-15.054,9.953-19.907a15.465,15.465,0,0,0-1.058-8.3l18.588-2.227a13.86,13.86,0,0,0-.3,7.751C488.6,293.971,499.969,301.075,499.969,301.075Z",
    transform: "translate(-6288.765 6493.062)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_415",
    "data-name": "Ellipse 415",
    cx: 18.588,
    cy: 18.588,
    r: 18.588,
    transform: "translate(-5832.292 6743.213)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10602",
    "data-name": "Path 10602",
    d: "M477.646,315.187s6.694-8.174,6.694-14.868a15.03,15.03,0,0,1,8.921-7.465c6.694-2.227,5.947,0,5.947,0l4.454,17.841-1.481,31.963.747,3.732H447.91l3.732-14.868-.747-12.641,2.974-19.322,8.921-5.2,6.694,8.921Z",
    transform: "translate(-6290.23 6496.792)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10603",
    "data-name": "Path 10603",
    d: "M470.138,292.09,447.1,295.822s-3.733-.746-8.174,17.1A253.811,253.811,0,0,0,433,346.348h28.74s1.729-29.736,6.221-31.963l6.221-9.617s-9.953-.784-8.485-5.984S470.138,292.09,470.138,292.09Z",
    transform: "translate(-6293.87 6496.847)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10604",
    "data-name": "Path 10604",
    d: "M485,290.3l24.523,11.894s2.974.746,1.48,12.641l1.481,31.963H486.057a95.31,95.31,0,0,0,1.12-30.47A203.675,203.675,0,0,1,485,290.3Z",
    transform: "translate(-6281.173 6496.41)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10605",
    "data-name": "Path 10605",
    d: "M472.527,267.492c-.323,3.011-2.389,5.487-4.106,7.988s-3.21,5.586-2.252,8.46c.373,1.12,1.107,2.115,1.369,3.272.448,1.991-.56,4.044-.386,6.072.236,2.787,2.6,4.852,3.907,7.316,2.762,5.213.647,11.67-2.339,16.746s-6.893,9.891-7.876,15.7c-.908,5.375.834,10.812,2.712,15.925a4.977,4.977,0,0,1,.423,3.2c-.572,1.717-2.725,2.227-4.541,2.351a47.869,47.869,0,0,1-5.96,0,4.976,4.976,0,0,1-2.177-.46c-1.369-.746-1.779-2.488-2.289-3.932s-1.63-3.086-3.185-2.924c-1.02.112-1.816.983-2.824,1.157a2.912,2.912,0,0,1-2.488-1.02c-1.854-2-1.406-5.238-.187-7.677s3.086-4.566,3.894-7.166c2-6.47-3.011-12.877-4.068-19.571a6.32,6.32,0,0,1,.174-3.285c.908-2.314,3.658-3.173,5.624-4.69,4.019-3.123,4.516-8.908,4.84-13.984a182.465,182.465,0,0,1,2.015-18.215,32.883,32.883,0,0,1,3.285-10.886,36.841,36.841,0,0,1,5.848-7.2c3.061-3.185,6.221-6.445,10.352-8.087a19.658,19.658,0,0,1,14.358.411,38.01,38.01,0,0,1,12.056,8.274A28.541,28.541,0,0,1,506.17,265.7c1.829,5.039,1.244,10.588,1.8,15.925a39.553,39.553,0,0,0,3.347,12.442c1.953,4.28,4.7,8.373,5.126,13.064.336,3.732-.883,7.465-1.505,11.135-1.095,6.432-.435,13.014.211,19.5a15.69,15.69,0,0,0,.946,4.616,16.413,16.413,0,0,0,4.429,5.313,1.9,1.9,0,0,1,.784,1.244,1.506,1.506,0,0,1-.585,1.095c-2.252,2-6.146.523-8.585,2.3a13.8,13.8,0,0,0-1.854,1.966,8.361,8.361,0,0,1-14.32-3.882c-.635-2.911.311-5.9.672-8.858,1.12-9.344-3.658-18.227-7.465-26.824-1.792-4.019-3.422-8.373-2.762-12.728.535-3.5,2.488-6.569,3.919-9.8,2.874-6.457,3.733-14.022,1.244-20.653A20.467,20.467,0,0,0,481.05,260.09c-1.767-.8-4.28-1.891-6.134-.821C471.843,261.072,472.776,264.718,472.527,267.492Z",
    transform: "translate(-6292.34 6485.451)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10606",
    "data-name": "Path 10606",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6731.593)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10607",
    "data-name": "Path 10607",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6741.546)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10608",
    "data-name": "Path 10608",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6751.5)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10609",
    "data-name": "Path 10609",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6761.453)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10610",
    "data-name": "Path 10610",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6771.406)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10611",
    "data-name": "Path 10611",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6781.36)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1483",
    "data-name": "Rectangle 1483",
    width: 89.58,
    height: 3.733,
    transform: "translate(-5730.83 6791.313)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 89.58,
    height: 3.733,
    transform: "translate(-5730.83 6801.266)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10612",
    "data-name": "Path 10612",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6811.22)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10613",
    "data-name": "Path 10613",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6821.173)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10614",
    "data-name": "Path 10614",
    d: "M1.866,0H87.714a1.867,1.867,0,1,1,0,3.733H1.866A1.867,1.867,0,1,1,1.866,0Z",
    transform: "translate(-5730.83 6831.126)",
    fill: "#e8eaf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10615",
    "data-name": "Path 10615",
    d: "M750.837,655.934l-4.977,32.348L716,682.062s6.221-21.151,7.465-26.128,1.244,0,1.244,0Z",
    transform: "translate(-6224.771 6585.146)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10616",
    "data-name": "Path 10616",
    d: "M642.837,682.062l-29.86,6.221-3.446-22.4L608,655.934h26.128s0-4.977,1.244,0c.448,1.792,1.543,5.7,2.774,9.953C640.348,673.427,642.837,682.062,642.837,682.062Z",
    transform: "translate(-6251.141 6585.146)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10617",
    "data-name": "Path 10617",
    d: "M638.166,665.887H609.55l-1.53-9.953h26.128s0-4.977,1.244,0C635.84,657.726,636.934,661.632,638.166,665.887Z",
    transform: "translate(-6251.136 6585.146)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10618",
    "data-name": "Path 10618",
    d: "M719.79,665.387h28.616l1.53-9.953H723.784s0-4.977-1.244,0C722.117,657.226,721.022,661.132,719.79,665.387Z",
    transform: "translate(-6223.845 6585.024)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10619",
    "data-name": "Path 10619",
    d: "M774.325,340.5s16.174,1.244,19.907,59.72a475.515,475.515,0,0,0,8.473,65.319,92.742,92.742,0,0,1-4.977,53.7l-15.938,38.99s-29.86-24.883-39.813-23.639c0,0,17.418-23.639,16.174-37.325S737,385.29,737,385.29Z",
    transform: "translate(-6219.643 6508.667)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10620",
    "data-name": "Path 10620",
    d: "M627.3,489.5s-38.569,23.639-47.278,33.592-4.977,49.767,0,65.941S616.106,703.5,616.106,703.5h31.1s-9.953-60.964-6.221-65.941-7.465-93.313-7.465-93.313Z",
    transform: "translate(-6259.247 6545.048)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10621",
    "data-name": "Path 10621",
    d: "M738.907,489.5s38.569,23.639,47.278,33.592,4.977,49.767,0,65.941S750.1,703.5,750.1,703.5H719s9.953-60.964,6.221-65.941,7.465-93.313,7.465-93.313Z",
    transform: "translate(-6224.038 6545.048)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10622",
    "data-name": "Path 10622",
    d: "M673.829,238.236s0,48.523-17.418,73.406,79.627,3.732,79.627,3.732a25.842,25.842,0,0,1-9.331-13.064c-5.126-18.252-7.067-50.4.622-64.075C738.526,218.33,673.829,238.236,673.829,238.236Z",
    transform: "translate(-6239.831 6481.537)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10623",
    "data-name": "Path 10623",
    d: "M743.785,587.238c-44.5,1.966-118.532,10.252-129.754-2.041-18.1-19.819-11.683-37.661-2.339-48.523,3.658-4.267,6.943-11.409,9.6-18.538.9-2.414,1.729-4.815,2.488-7.1,2.874-8.871,12.442-14.992,23.266-14.992h89.866c10.887,0,20.467,6.221,23.291,15.092a39.92,39.92,0,0,0,5.723,11.633,28.167,28.167,0,0,0,4.591,4.977c4.529,3.845,7.465,12.131,9.369,21.25C783.909,568.3,766.889,586.217,743.785,587.238Z",
    transform: "translate(-6252.481 6546.645)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10624",
    "data-name": "Path 10624",
    d: "M634.222,675.516c-3.894-.784-14.059-3.023-18-6.022a1.978,1.978,0,0,0-2.986.834l-6.1,14.2s-24.883-11.2-26.128,14.93c-.722,15.241,7.017,20.74,13.6,22.681a51.182,51.182,0,0,1,16.261,7.8c5.984,4.454,15.1,9.02,25.456,6.557a24.265,24.265,0,0,1,6.383-.622c4.641.149,12.641-1.244,11.757-12.8,0,0-7.465-29.86-4.977-34.837,1.568-3.135,1.157-11.2.647-16.747a1.381,1.381,0,0,0-2.488-.635,10.949,10.949,0,0,1-9.593,4.977,17.418,17.418,0,0,1-3.832-.316Z",
    transform: "translate(-6257.742 6588.904)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10625",
    "data-name": "Path 10625",
    d: "M634.222,676.516c-3.894-.784-14.059-3.023-18-6.022a1.978,1.978,0,0,0-2.986.834l-6.1,14.2s-24.883-11.2-26.128,14.93c-.722,15.241,7.017,20.74,13.6,22.681a51.184,51.184,0,0,1,16.261,7.8c5.984,4.454,15.1,9.02,25.456,6.557a24.267,24.267,0,0,1,6.383-.622c4.641.149,12.641-1.244,11.757-12.8,0,0-7.465-29.86-4.977-34.837,1.568-3.135,1.157-11.2.647-16.747a1.381,1.381,0,0,0-2.488-.634,10.948,10.948,0,0,1-9.593,4.977,17.412,17.412,0,0,1-3.832-.311Z",
    transform: "translate(-6257.742 6589.149)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10626",
    "data-name": "Path 10626",
    d: "M732.236,675.516c3.894-.784,14.059-3.023,18-6.022a1.978,1.978,0,0,1,2.986.834l6.059,14.2s24.883-11.2,26.128,14.93c.722,15.241-7.017,20.74-13.6,22.681a51.182,51.182,0,0,0-16.174,7.826c-5.984,4.454-15.1,9.02-25.456,6.557a24.255,24.255,0,0,0-6.383-.622c-4.641.149-12.641-1.244-11.757-12.8,0,0,7.465-29.86,4.977-34.837-1.568-3.135-1.157-11.2-.647-16.747a1.381,1.381,0,0,1,2.488-.635,10.949,10.949,0,0,0,9.593,4.977A17.414,17.414,0,0,0,732.236,675.516Z",
    transform: "translate(-6225.753 6588.904)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10627",
    "data-name": "Path 10627",
    d: "M732.236,676.516c3.894-.784,14.059-3.023,18-6.022a1.978,1.978,0,0,1,2.986.834l6.059,14.2s24.883-11.2,26.128,14.93c.722,15.241-7.017,20.74-13.6,22.681a51.185,51.185,0,0,0-16.174,7.826c-5.984,4.454-15.1,9.02-25.456,6.557a24.267,24.267,0,0,0-6.383-.622c-4.641.149-12.641-1.244-11.757-12.8,0,0,7.465-29.86,4.977-34.837-1.568-3.135-1.157-11.2-.647-16.747a1.381,1.381,0,0,1,2.488-.635,10.949,10.949,0,0,0,9.593,4.977,17.406,17.406,0,0,0,3.782-.336Z",
    transform: "translate(-6225.753 6589.149)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 20.802,
    height: 23.776,
    transform: "translate(-5562.071 7329.34)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1486",
    "data-name": "Rectangle 1486",
    width: 34.177,
    height: 145.63,
    transform: "translate(-5566.538 7162.921)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10631",
    "data-name": "Path 10631",
    d: "M571.73,755.173s-14.868-11.882,124.865-49.033h28.23s120.323,29.686,121.8,49.033H828.8s-65.381-19.347-95.1-19.347S614.82,738.8,588.132,755.148Z",
    transform: "translate(-6260.109 6597.944)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7775",
    "data-name": "Group 7775",
    transform: "translate(-5696.541 7015.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1487",
    "data-name": "Rectangle 1487",
    width: 16.348,
    height: 120.361,
    transform: "translate(11.882 17.842)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1488",
    "data-name": "Rectangle 1488",
    width: 38.631,
    height: 4.454,
    transform: "translate(11.882 136.71)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10632",
    "data-name": "Path 10632",
    d: "M542.774,419.77h6.283a16.174,16.174,0,0,1,16.174,16.174v7.6H526.6v-7.6A16.174,16.174,0,0,1,542.774,419.77Z",
    transform: "translate(-526.6 -419.77)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7776",
    "data-name": "Group 7776",
    transform: "translate(-5455.819 7015.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    width: 16.348,
    height: 120.361,
    transform: "translate(26.75 17.842)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1490",
    "data-name": "Rectangle 1490",
    width: 43.017,
    height: 4.454,
    transform: "translate(0 136.71)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10633",
    "data-name": "Path 10633",
    d: "M748.174,419.77h6.283a16.174,16.174,0,0,1,16.174,16.174v7.6H732v-7.6A16.174,16.174,0,0,1,748.174,419.77Z",
    transform: "translate(-717.17 -419.77)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_416",
    "data-name": "Ellipse 416",
    cx: 10.401,
    cy: 10.401,
    r: 10.401,
    transform: "translate(-5691.352 7351.873)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_417",
    "data-name": "Ellipse 417",
    cx: 10.401,
    cy: 10.401,
    r: 10.401,
    transform: "translate(-5562.071 7351.873)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 10.401,
    cy: 10.401,
    r: 10.401,
    transform: "translate(-5431.309 7351.873)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10634",
    "data-name": "Path 10634",
    d: "M705.058,603.235h99.533l7.465-14.855c4.454-25.257-11.882-26.75-11.882-26.75H609.953s-16.348,1.481-11.882,26.75l7.465,14.855Z",
    transform: "translate(-6251.514 6559.687)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    cx: 41.222,
    cy: 41.222,
    r: 41.222,
    transform: "translate(-5579.891 6663.328)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10635",
    "data-name": "Path 10635",
    d: "M892.718,382.167a7.71,7.71,0,0,0-4.939-6.855,23.216,23.216,0,0,0-5.869-1.12c-5.855-.728-11.869-2.8-15.273-7.121-4.537-5.749-3.3-13.791-6.933-20.033A69.856,69.856,0,0,0,854.165,340c-6.339-8.2-7.466-18.683-8.04-28.643a11.914,11.914,0,0,1,.7-5.99,23.167,23.167,0,0,1,3.918-4.673,15.208,15.208,0,0,0,3.886-10.359c-.185-7.719,11.236-12.9,19.338-15.572s16.872-3.091,25.5-3.2c4.958-.065,10.074-.008,14.631,1.741a33.93,33.93,0,0,1,7.336,4.219c9.55,6.756,18.515,15.061,21.724,25.571a53.524,53.524,0,0,1,1.741,14.685,9.318,9.318,0,0,1-.68,4.52c-1.146,2.227-3.849,3.432-5.594,5.32-3.263,3.527-2.676,8.631-3.1,13.2a30.17,30.17,0,0,1-15.363,22.859,19.627,19.627,0,0,0-4.8,3.209,20.218,20.218,0,0,0-2.649,4.471C909.27,377.725,900.614,381.942,892.718,382.167Z",
    transform: "translate(-6427.588 6374.453)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7778",
    "data-name": "Group 7778",
    transform: "translate(-1352.653 666.965)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10652",
    "data-name": "Path 10652",
    d: "M423.463,178.626h-.627V161.461a9.935,9.935,0,0,0-9.935-9.935H376.534a9.935,9.935,0,0,0-9.934,9.934V255.63a9.935,9.935,0,0,0,9.935,9.935H412.9a9.935,9.935,0,0,0,9.935-9.935V190.844h.627Z",
    transform: "translate(-4800.766 5842.61)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10653",
    "data-name": "Path 10653",
    d: "M421.368,161.71h-4.747a3.525,3.525,0,0,1-3.263,4.856H392.524a3.525,3.525,0,0,1-3.263-4.856h-4.434a7.419,7.419,0,0,0-7.419,7.419V263.16a7.419,7.419,0,0,0,7.419,7.419h36.541a7.419,7.419,0,0,0,7.419-7.419h0V169.128a7.419,7.419,0,0,0-7.419-7.419Z",
    transform: "translate(-4808.832 5835.076)",
    fill: "#8b8793"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10628",
    "data-name": "Path 10628",
    d: "M556.528,269.635s11.2-36.081-18.663-41.058-22.4,38.569,0,54.743S556.528,269.635,556.528,269.635Z",
    transform: "translate(-6273.074 6481.243)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10629",
    "data-name": "Path 10629",
    d: "M707.663,270.434H700.2s-4.977,22.4-21.151,22.4c-4.317,0-10.215-.261-16.56-.659a166.618,166.618,0,0,0-56.46,6.756c-6.308,1.829-13.238,1.991-19.048-2.364-14.93-11.2-31.1-41.058-31.1-41.058s-28.616-1.244-29.86,14.93,13.679,46.03,17.412,49.761,3.732,27.372,29.86,33.593,44.79,8.709,46.034,39.813,26.128,63.453,13.686,99.533,1.244,43.546,1.244,43.546,116.952,64.7,151.789,7.465c0,0-13.686-38.569,0-57.232s7.465-64.7,7.465-64.7l44.79-44.79s1.244-28.616-17.418-43.546-62.208-38.569-62.208-38.569l4.355-18.488Z",
    transform: "translate(-6271.177 6487.908)",
    fill: "#a47cea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10630",
    "data-name": "Path 10630",
    d: "M702.574,632.994c92.068,3.592,95.1-35.882,95.1-35.882l-5.947-109.455c-1.48-170.469-89.157-145.35-89.157-145.35s-87.677-25.063-89.157,145.35L607.47,597.112S610.444,636.586,702.574,632.994Z",
    transform: "translate(-6249.031 6493.854)",
    fill: "#090814"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhConsumerSnapshotTaking);
export default __webpack_public_path__ + "static/media/nh_consumer_snapshot_taking.fe46cbb67923984f2b22d0d829a168b9.svg";
export { ForwardRef as ReactComponent };